goog.provide("shadow.js.shim.module$react_use$lib$useBeforeUnload");
goog.provide("module$shadow_js_shim_module$react_use$lib$useBeforeUnload");
shadow.js.shim.module$react_use$lib$useBeforeUnload = shadow.js.nativeProvides["react-use/lib/useBeforeUnload"] = shadow$bridge("react-use/lib/useBeforeUnload");
module$shadow_js_shim_module$react_use$lib$useBeforeUnload.default = shadow.js.shim.module$react_use$lib$useBeforeUnload;
